import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TransformationSection() {
  return <section className="w-full py-20 md:py-32 px-6 bg-navy relative" data-id="element-141">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-warm-radial opacity-20 pointer-events-none" data-id="element-142" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-143">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-5xl font-bold text-cream mb-16 text-center" data-id="element-144">
          ¿Y QUÉ CAMBIA EN MI VIDA?
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-145">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-4" data-id="element-146">
            <div className="flex items-start" data-id="element-147">
              <CheckCircle2 className="w-8 h-8 text-gold flex-shrink-0 mr-4 mt-1" data-id="element-148" />
              <div data-id="element-149">
                <h3 className="text-2xl font-bold text-cream mb-3" data-id="element-150">
                  1. Tu noche deja de ser improvisación.
                </h3>
                <p className="text-lg text-cream-muted leading-relaxed" data-id="element-151">
                  Cuando ocurre el despertar, no discutes contigo misma.
                  Ejecutas. Sabes exactamente qué paso sigue.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-4" data-id="element-152">
            <div className="flex items-start" data-id="element-153">
              <CheckCircle2 className="w-8 h-8 text-gold flex-shrink-0 mr-4 mt-1" data-id="element-154" />
              <div data-id="element-155">
                <h3 className="text-2xl font-bold text-cream mb-3" data-id="element-156">
                  2. Tu cerebro deja de asociar 3AM con alerta.
                </h3>
                <p className="text-lg text-cream-muted leading-relaxed" data-id="element-157">
                  Porque le quitas lo que más alimenta el bucle: reloj, pelea,
                  celular, tensión.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="mt-16 text-center p-8 border-t border-b border-navy-lighter" data-id="element-158">
          <p className="text-2xl md:text-3xl font-serif text-gold italic" data-id="element-159">
            «No te prometo ‹nunca más›. Te prometo algo mejor: control.»
          </p>
        </motion.div>
      </div>
    </section>;
}